export enum AppCurrency {
  PLN = "PLN",
  EUR = "EUR",
}